import React, { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import DynamicSidebar from "../components/sidebar/DynamicSidebar";
import useAuth from "../hooks/useAuth";
import "./admin-layout.css";

function titleFromPath(pathname) {
  const mapping = {
    "/dashboard": "Dashboard",
    "/setup": "Organization Setup",
    "/variations/initiate": "Initiate Variation",
    "/variations/review": "Variation Review",
    "/payroll/run": "Payroll Run",
    "/payroll/preview": "Payroll Preview",
    "/reports": "Reports",
  };

  if (mapping[pathname]) {
    return mapping[pathname];
  }

  const segments = pathname.split("/").filter(Boolean);
  if (!segments.length) {
    return "Dashboard";
  }

  return segments
    .slice(-1)[0]
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const title = useMemo(() => titleFromPath(location.pathname), [location.pathname]);
  const breadcrumb = useMemo(
    () =>
      location.pathname
        .split("/")
        .filter(Boolean)
        .map((part) => part.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())),
    [location.pathname]
  );

  return (
    <div className="payroll-shell">
      <DynamicSidebar />

      <div className="payroll-shell__main">
        <header className="payroll-shell__header">
          <div>
            <div className="payroll-shell__eyebrow">Enterprise Payroll</div>
            <h1>{title}</h1>

            <div className="payroll-shell__breadcrumb">
              <span>Home</span>
              {breadcrumb.map((item) => (
                <React.Fragment key={item}>
                  <span className="payroll-shell__breadcrumb-sep">/</span>
                  <span>{item}</span>
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="payroll-shell__actions">
            <div className="payroll-shell__search">
              <input type="text" placeholder="Search employees, payroll runs, variations..." />
            </div>

            <div className="payroll-shell__user">
              <div className="payroll-shell__avatar">
                {(user?.name || "U").charAt(0).toUpperCase()}
              </div>
              <div className="payroll-shell__user-meta">
                <strong>{user?.name || "Super Admin"}</strong>
                <span>{user?.role?.name || "Administrator"}</span>
              </div>
            </div>

            <button type="button" className="payroll-shell__logout" onClick={logout}>
              Logout
            </button>
          </div>
        </header>

        <main className="payroll-shell__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
